export default __webpack_public_path__ + "static/media/Festrahmenfenster S.e111d7c1.jpg";